<template>
  <transition name="pg-tabpane-fade" mode="out-in">
    <div class="pg-tab-pane" v-if="load" v-show="active === name">
      <slot></slot>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'PgTabPane',
}
</script>
<script setup>
import { inject, onMounted, ref, watch } from 'vue'
const props = defineProps({
  label: String,
  name: String,
  lazy: Boolean,
})

const INJECTKEY = 'PGTABS_INJECT_KEY'
const active = inject(INJECTKEY)
const load = ref(false)
onMounted(() => {
  load.value = !props.lazy || active.value === props.name
})
watch(active, () => {
  if (!load.value && active.value === props.name) {
    load.value = true
  }
})
</script>
<style lang="scss">
@import '../style/tab-pane.scss';
</style>
